import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import Description from "../../description/Description";
import { requiredValidation } from "../../../utilities/Validation";
import Label from "../../label/label";

interface DetailStepProps {
    onNext: (e) => void;
    setAccessProfileName: React.Dispatch<React.SetStateAction<string>>;
}

const DetailStep: FC<DetailStepProps> = ({ onNext, setAccessProfileName }) => {
    const { values, errors } = useFormikContext<any>();
    const { translate } = useLocale();

    const onLocalNext = (e) => {
        setAccessProfileName(values.name);
        onNext(e);
    }

    return <div className="pt-3 pr-3 h-full relative">
        <div className={`text-portal-blue-primary-shade2 text-xl font-semibold`} >
            {translate.byKey(TranslationKeys.details)}
        </div>
        <div className="flex flex-col flex-1">
            <div className="flex flex-row justify-between">
                <Label
                    htmlFor="name"
                    className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                {errors.name ? <span className='text-red-600 text-xs'>{errors.code}</span> : null}
            </div>
            <Field
            
                id="nameField"
                type="text"
                name="name"
                className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                validate={(value) => requiredValidation(value, translate)} />
        </div>
        <div className="flex flex-col flex-1 mt-2">
            <div className="flex flex-row justify-between">
                <Label
                    htmlFor="name"
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.description)}:</Label>
            </div>
            <Description                              
                accessor="description"
                title=""
                isRequired={true} />
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    id="nextBtn"
                    className={`py-1 px-5 secondary ${values.name ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    onClick={values.name && onLocalNext}>
                    {translate.byKey(TranslationKeys.next)}
                </button>
            </div>
        </div>
    </div>
}

export default DetailStep;